export var TelemetryType = {
  log: 'log',
  configuration: 'configuration',
  usage: 'usage'
}

export var TelemetryStatusType = {
  debug: 'debug',
  error: 'error'
}
